module.exports = __webpack_public_path__ + "static/img/logo.897635f1.png";